export const formatRequestOptions = (options?: IRequestPaginatedOptions): IRequestPaginatedParams => ({
  page: options?.page || 0,
  size: options?.pageSize || 10,
  sort: options?.sort,
  order: options?.order,
  next: true,
  count: options?.count || false,
});
